
import React from 'react';
import { NikoFacilityOrderNewFlowExtraSuppliesAddModalTemplate } from 'themes/application/niko-facility-order-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoFacilityOrderNewFlowExtraSuppliesAddModalViewStore } from 'application/niko-facility-order-inventory/stores';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderNewFlowExtraSuppliesAddModalViewStore(rootStore, componentProps), 'nikoFacilityOrderNewFlowExtraSuppliesAddModalViewStore')
@observer
class NikoFacilityOrderNewFlowExtraSuppliesAddModal extends React.Component {
    render() {
        return <NikoFacilityOrderNewFlowExtraSuppliesAddModalTemplate {...this.props} />
    }
}

export default NikoFacilityOrderNewFlowExtraSuppliesAddModal;
